import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import getValueFees from 'core/controllerPlans/getValueFees'
import getPlanAsURL from 'core/controllerPlans/getPlanAsURL'
import moneyFormat from 'utils/format/money'
import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'
import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'
import { getBenefits } from 'core/controllerPlans/getBenefits'
import getValidDuration from 'utils/pivot/plan/getValidDuration'

const asMoney = moneyFormat
const MISSING_DURATION_ERROR = 'PPI-1399: missing duration pricing for plan'

const getDuration = ({ plan, period, policies, isBTM, isMultiCarrier }) => {
  if (isBTM || isMultiCarrier) {
    return plan.durations?.[0]
  }

  if (!plan.durations) return undefined

  const durations = getAndValidatePeriod(plan, period)
  return durations && getValidDuration(durations, policies)
}

/**
 * Adapts a raw plan (as stored in state.plans or responsePlans.plans) into the
 * flat shape expected by makeComparisonPayload. Covers single-carrier, BTM, and
 * multi-carrier plans.
 */
function toComparisonShape({
  plan,
  allPlans,
  brochures,
  carriers,
  period,
  policies
}: {
  plan: any
  allPlans: Record<string, any>
  brochures: Record<string, string>
  carriers: Record<string, any>
  period: number
  policies: number
}): ComparePage.Plan {
  const planId = plan.planId
  const isBTM = isBTMPlan(plan)
  const isMultiCarrier = plan?.multiCarrierPlan

  const duration = getDuration({ plan, period, policies, isBTM, isMultiCarrier })

  const planName = `${plan.planName}${policies > 1 ? ' Added Coverage' : ''}`
  const parsed = {
    ...plan,
    planName,
    period,
    policies,
    coreBenefits: { ...plan.coreBenefits }
  }
  const paidInformationPlan = duration?.monthly

  if (!paidInformationPlan) {
    throw new Error(`${MISSING_DURATION_ERROR} ${planId}`)
  }

  parsed.coreBenefits.rxScheduleText = parsed.coreBenefits.rxScheduleDescription
  parsed.monthlyPremium = asMoney(paidInformationPlan.premium)
  parsed.brochure = brochures[parsed.brochureId]
  parsed.carrier = carriers[parsed.carrierId]
  parsed.fee = getValueFees('Application Fee', paidInformationPlan.fees)
  parsed.planAsURL = getPlanAsURL({
    plans: allPlans,
    planId,
    filters: { period, policies }
  })
  parsed.planTypeKey = getPlanTypeKey(plan)
  parsed.benefits = getBenefits(plan)

  return parsed
}

export default toComparisonShape
